export const urls = {
  newsletter_sign_up: '/newsletter/sign_up',
  send_contact_message: '/contact/send_message',
  offer_availability_check: '/offers/available',
  offers_list: '/offers/list',
  special_offers_list: '/api/special_offers_list',
  send_reservation: '/reservation',
  send_agent_reservation: '/agent_reservation',
  reservation: '/reservation',
  reservation_documents: '/reservation/documents',
  book_offer: '/reservation/book',
  book_offer_with_insurance: '/reservation/book_with_insurance',
  get_traffics_insurances: '/traffics_insurances',
  offer_description: '/offers/description',
  operator_img: '/img/partners',
  offer_variants_list: '/offers/for_hotel',
  offer_show: '/offers/show_offer',
  hotel_show: '/offers/show_hotel',
  default_filter: '/filter/get_default_filter',
  airports_filter: '/filter/airports',
  regions_filter: '/filter/regions',
  facilities_filter: '/filter/facilities',
  operators_filter: '/filter/operators',
  ask_for_offer: '/offers/ask_for_offer',
  send_on_email: '/offers/send_on_email',
  add_to_new_favourites: '/ulubione/add',
  add_to_favourites: '/ulubione/{fav_uuid}/add',
  remove_from_favourites: '/ulubione/{fav_uuid}/destroy',
  remove_all_from_favourites: '/ulubione/{fav_uuid}/destroy_all',
  send_favourites_on_email: '/ulubione/{fav_uuid}/send_on_email',
  send_favourites_pdf_on_email: '/ulubione/{fav_uuid}/send_pdf_on_email',
  generate_pdf_offer: '/ulubione/{fav_uuid}/generate_pdf',
  get_curiosities: '/blog/get_curiosity',
  get_hotel: '/offers/show_hotel',
  offer_types_list: {
    S: '/tylko-hotele',
    A: '/wakacje',
    C1: '/loty-w-jedna-strone',
    C2: '/loty-w-dwie-strony'
  },
  hotel_upgrades: '/offers/variants',
  hotel_facts: '/offers/facts',
  send_contact_me_message: '/contact/contact_me',
  blog_related_offers: '/blog/related_offers',
  get_hotels_list: '/offers/get_hotels_list',
  get_recommended_regions: '/regions/get_recommended_regions',
  group_reservation: '/reservation/group_reservation'
};



// WEBPACK FOOTER //
// ./app/javascript/services/urls.js